export default "__VITE_ASSET__CV7UG735__"